import React from 'react';
import {
  useEventContext, EmitEvent, AddEvent, RemoveEvent,
} from './EventProvider';

export interface WithEventProps {
  emit: EmitEvent, on: AddEvent, remove: RemoveEvent
}

export function withEvent<P>(WrappedComponent: React.ComponentType<P>) {
  return (props: P & Partial<WithEventProps>) => {
    const { emit, on, remove } = useEventContext();

    return <WrappedComponent onEvent={on} fireEvent={emit} removeEvent={remove} {...props} />;
  };
}
